// WHAT: React Context for sidebar state management
// WHY:  Provides context definition for sidebar open/close state
// DOMAIN: core → layout
// DEPENDENCIES: React createContext
// RISKS:
//   - NOTE: Context must be used innerhalb des SidebarProvider

import { createContext } from "react";

interface SidebarContextType {
  close: () => void;
  isOpen: boolean;
  open: () => void;
  toggle: () => void;
}

/**
 * WHAT:
 *   React Context for sidebar state and control functions.
 *
 * WHY:
 *   Enables sidebar state sharing across components without prop drilling.
 *
 * BEHAVIOR:
 *   - Provides sidebar state (isOpen) and control functions (toggle, open, close)
 *   - Must be used within SidebarProvider
 *
 * RISKS:
 *   - NOTE: Context value is null by default - must be provided by SidebarProvider
 */
export const SidebarContext = createContext<null | SidebarContextType>(null);
